function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(';').shift());
  }
  return null;
}

document.addEventListener("DOMContentLoaded", function () {
  var quizNameEl = document.getElementById('quiz-name');
  var quizName = getCookie("quizName");

  if (quizNameEl && quizName) {
    quizNameEl.textContent = quizName;
  }
});


function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

document.addEventListener("DOMContentLoaded", function () {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  }

  var productHandle = getCookie("product_handle");

  fetch('/products/' + productHandle + '.js')
    .then(response => response.json())
    .then(product => {

        const mainWrapper = document.getElementById('main-swiper-wrapper');

        mainWrapper.innerHTML = '';

        let slidesHTML = '';

        product.images.forEach((imageUrl) => {
          slidesHTML += `<img src="${imageUrl}" class="swiper-slide w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 object-contain" loading="lazy" width="100%" height="100%">`;
        });

        mainWrapper.innerHTML = slidesHTML;

        const mainSwiper = new Swiper(".mainSwiper", {
          spaceBetween: 40,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });


      document.querySelector('[data-id="element-40"]').textContent = product.title;
      document.querySelector('[data-product-id]')?.setAttribute('data-product-id', product.id);
      document.querySelector('[data-only-subscription]')?.setAttribute('data-only-subscription', false);
      document.querySelector('[data-product-available]')?.setAttribute('data-product-available', true);


      const container = document.querySelector('[data-id="element-4"]');
      container.innerHTML = ''; // clear existing

      let lowestPerDay = Infinity;
      let bestVariantId = null;

      const fieldset = document.createElement("fieldset");
      fieldset.className = "variant-section product-form__controls-group";
      fieldset.id = "SingleOptionSelector-0";

      product.variants.forEach((variant, index) => {
        const price = variant.price / 100;
        const compare = variant.compare_at_price ? variant.compare_at_price / 100 : null;
        const save = compare ? (compare - price) : 0;
        const discountPercent = compare ? Math.round((save / compare) * 100) : 0;

        const daysMatch = variant.title.match(/\d+/);
        const days = daysMatch ? parseInt(daysMatch[0]) : 1;
        const perDay = Math.round(price / days);

        if (perDay < lowestPerDay) {
          lowestPerDay = perDay;
          bestVariantId = variant.id;
        }

        const optionDiv = document.createElement("div");
        optionDiv.className = "variant-option";

        const inputId = `SingleOptionSelector-packs-${variant.title
          .toLowerCase()
          .replace(/\s+/g, "-")}`;

        optionDiv.innerHTML = `
          <input 
            type="radio"
            class="single-option-selector product-form__input"
            name="packs"
            id="${inputId}"
            value="${variant.title}"
            data-variant-id="${variant.id}"
            ${index === 0 ? "checked" : ""}
          >

          <div class="radio-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-check h-3.5 w-3.5">
              <path d="M20 6 9 17l-5-5"></path>
            </svg>
          </div>

          <label for="${inputId}">
            
            ${days === 60 ? `
              <div class="ontime-badge badge-recommended absolute -top-2 left-1/2 -translate-x-1/2 
                bg-gradient-to-r from-setu-500 to-setu-400 text-white px-3 py-0.5 
                rounded-full text-xs font-bold uppercase tracking-wide shadow-sm">
                Recommended
              </div>
            ` : ""}

            ${days === 90 ? `
              <div class="ontime-badge badge-bestvalue absolute -top-2 left-1/2 -translate-x-1/2 
                bg-gradient-to-r from-setu-500 to-setu-400 text-white px-3 py-0.5 
                rounded-full text-xs font-bold uppercase tracking-wide shadow-sm">
                Best Value
              </div>
            ` : ""}

            <div class="variant-details">
              <span class="variant-title onetime">${variant.title}</span>
              <span class="variant-title subscribe">Delivery every ${days} days</span>

              ${save > 0 ? `
                <span class="variant-discount-amount">
                  Save: ₹${save} (${discountPercent}% off)
                </span>
              ` : ""}

              <div class="saveExtrabadge">
                <span class="saveExtra">Save Extra ${discountPercent}%</span>
                <span class="saveperDay">₹${perDay} / day</span>
              </div>
            </div>

            <div class="variant-pricing">
              <span class="variant-asp">₹${price}</span>
              ${compare ? `<span class="variant-mrp onetime">₹${compare}</span>` : ""}
            </div>
          </label>
        `;

        fieldset.appendChild(optionDiv);
      });

      container.appendChild(fieldset);

      function updateSelectedVariant(radio) {
        if (!radio) return;

        const selectedVariant = radio.dataset.variantId;
        document.querySelector('[name="id"]').value = selectedVariant;
        const selectedVariantData = product.variants.find(
          v => v.id == selectedVariant
        );

        if (!selectedVariantData) return;

        const newPrice = selectedVariantData.price / 100;
        document.querySelector('[data-id="element-95"]').textContent = `₹${newPrice}`;
      }

      document.querySelectorAll('input[name="packs"]').forEach(radio => {
        radio.addEventListener("change", function () {
          updateSelectedVariant(this);
        });
      });

      window.addEventListener("DOMContentLoaded", function () {
        const checkeRadio = document.querySelector('input[name="packs"]:checked');
        
        updateSelectedVariant(checkeRadio);
      });


      const variantOptions = document.querySelectorAll('.variant-option');

      if (variantOptions.length > 0) {
        const firstOption = variantOptions[0];
        const firstRadio = firstOption.querySelector('input[type="radio"]');

        if (firstRadio) {
          firstRadio.checked = true;
          firstOption.classList.add('variant-option--active');
        }
      }

      document.querySelectorAll('input[name="packs"]').forEach(radio => {
        radio.addEventListener('change', function () {

          variantOptions.forEach(option => {
            option.classList.remove('variant-option--active');
          });

          const parent = this.closest('.variant-option');
          if (parent) {
            parent.classList.add('variant-option--active');
          }

        });
      });

      const checkRadio = document.querySelector('input[name="packs"]:checked');
      const selectedriant = checkRadio.dataset.variantId;
      document.querySelector('[name="id"]').value = selectedriant;
      const selectVariantData = product.variants.find(
        v => v.id == selectedriant
      );

      if (!selectVariantData) return;

      const selectedPrice = selectVariantData.price / 100;
      document.querySelector('[data-id="element-95"]').textContent = `₹${selectedPrice}`;


    })
    .catch(error => {
      console.log("Product not found");
    });
});



document.addEventListener("DOMContentLoaded", function () {
    const purchaseOptions = document.querySelectorAll(".purchase-option");
    const optionButtons = document.querySelectorAll(".optionButton");

    purchaseOptions.forEach(option => {
      option.addEventListener("click", function () {
        const selectedOption = this.dataset.option; // addtocart | subscribesave

        /* ---- Toggle purchase-option active ---- */
        purchaseOptions.forEach(o => {
          o.classList.remove("active");
          o.setAttribute("aria-checked", "false");
        });

        this.classList.add("active");
        this.setAttribute("aria-checked", "true");

        /* ---- Toggle CTA buttons ---- */
        optionButtons.forEach(btn => btn.classList.remove("active"));

        const targetButton = document.querySelector(
          `.optionButton.${selectedOption}`
        );
        if (targetButton) {
          targetButton.classList.add("active");
        }

        /* ---- NEW TWIST: Auto click based on data-option ---- */
        if (selectedOption === "subscribesave") {
          const subscriptionEl = document.querySelector(
            '[data-type="subscription-purchase"] input'
          );
          subscriptionEl?.click();
        }

        if (selectedOption === "addtocart") {
          const oneTimeEl = document.querySelector(
            '[data-type="onetime-purchase"] input'
          );
          oneTimeEl?.click();
        }

            
        /* ---- NEW TWIST: Replace variant group class ---- */
        const variantGroup = document.querySelector(".product-form__controls-group1");
        const purchaseFooter = document.querySelector(".purchase-footer");
        
        if (variantGroup) {
          variantGroup.classList.remove("onetime", "subscribesave");

          if (selectedOption === "addtocart") {
            variantGroup.classList.add("onetime");
          }

          if (selectedOption === "subscribesave") {
            variantGroup.classList.add("subscribesave");
          }
        }

        if (purchaseFooter) {
          purchaseFooter.classList.remove("onetime", "subscribesave");

          if (selectedOption === "addtocart") {
            purchaseFooter.classList.add("onetime");
          }

          if (selectedOption === "subscribesave") {
            purchaseFooter.classList.add("subscribesave");
          }
        }

      });
    });

    const subscribesave = document.querySelector(".optionButton.subscribesave");
    subscribesave.addEventListener("click", function () {
      document.querySelector('[data-recurpay-action]')?.click();
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const purchaseOptions = document.querySelectorAll(".purchase-option");
    const variantOptions = document.querySelectorAll(".variant-option");

    function formatPrice(number) {
      return "₹" + number.toLocaleString("en-IN");
    }

    function getActivePurchaseType() {
      return document.querySelector(".purchase-option.active")?.dataset.option;
    }

    function updateAllVariantPrices() {
      const purchaseType = getActivePurchaseType();

      variantOptions.forEach(variant => {
        const input = variant.querySelector('input[name="packs"]');
        const aspEl = variant.querySelector(".variant-asp");

        if (!input || !aspEl) return;

        // Store original price once
        if (!aspEl.dataset.originalPrice) {
          aspEl.dataset.originalPrice = aspEl.innerText.replace(/[₹,]/g, "");
        }

        const originalPrice = parseInt(aspEl.dataset.originalPrice, 10);

        if (purchaseType === "subscribesave") {
          const discountPercent = parseInt(
            input.dataset.discount.replace("%", ""),
            10
          );

          const discountedPrice = Math.round(
            originalPrice - (originalPrice * discountPercent) / 100
          );

          aspEl.innerText = formatPrice(discountedPrice);
        } else {
          aspEl.innerText = formatPrice(originalPrice);
        }
      });
    }

    purchaseOptions.forEach(option => {
      option.addEventListener("click", function () {
        purchaseOptions.forEach(o => o.classList.remove("active"));
        this.classList.add("active");
        updateAllVariantPrices();
      });
    });

    updateAllVariantPrices();
  });

  document.addEventListener("DOMContentLoaded", function () {
    const youSaveEls = document.querySelectorAll(".yousaveExtraSave");
    const purchaseOptions = document.querySelectorAll(".purchase-option");

    function isSubscribeActive() {
      return document.querySelector(
        '.purchase-option.active[data-option="subscribesave"]'
      );
    }

    function updateYouSave() {
      const checkedInput = document.querySelector('input[name="packs"]:checked');
      if (!checkedInput || !youSaveEls.length) return;

      if (!isSubscribeActive()) {
        return;
      }

      const discount = checkedInput.getAttribute("data-discount");

      if (discount) {
        youSaveEls.forEach(el => {
          el.textContent = discount;
        });
      }
    }

    updateYouSave();

    document.querySelectorAll('input[name="packs"]').forEach(input => {
      input.addEventListener("change", updateYouSave);
    });

    purchaseOptions.forEach(option => {
      option.addEventListener("click", function () {
        setTimeout(updateYouSave, 50);
      });
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const supplyEl = document.querySelector(".supply");
    const supplyPriceEl = document.querySelector(".supplyprice");
    const purchaseOptions = document.querySelectorAll(".purchase-option");

    function updateSupply() {
      const checkedInput = document.querySelector('input[name="packs"]:checked');
      if (!checkedInput) return;

      const variantOption = checkedInput.closest(".variant-option");
      if (!variantOption) return;

      const title = variantOption.querySelector(".variant-title")?.innerText;
      const price = variantOption.querySelector(".variant-asp")?.innerText;

      if (supplyEl && title) supplyEl.textContent = title;
      if (supplyPriceEl && price) supplyPriceEl.textContent = price;
    }

    updateSupply();

    document.querySelectorAll('input[name="packs"]').forEach(input => {
      input.addEventListener("change", function () {
        setTimeout(updateSupply, 50); // small delay for price update
      });
    });

    purchaseOptions.forEach(option => {
      option.addEventListener("click", function () {
        setTimeout(updateSupply, 300); // wait for subscribe price logic
      });
    });
  });

  const purchaseOptions = document.querySelectorAll(".purchase-option");
  purchaseOptions.forEach(option => {
    option.addEventListener("click", function () {
      const selectedOption = this.dataset.option; // addtocart | subscribesave

      const stickyBtn = document.getElementById("stickyAddToCartBtnATC");
      const mainAtcBtn = document.getElementById("atc_pdp_fold");
      const mainAtc = document.getElementById("atc_pdp_fold");

      /* ---- NEW TWIST: Auto click based on data-option ---- */
      if (selectedOption === "subscribesave") {
        const subscriptionEl = document.querySelector(
          '[data-type="subscription-purchase"] input'
        );
        subscriptionEl?.click();

        stickyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          mainAtc.click();
        });
      }

      if (selectedOption === "addtocart") {   
        if (!stickyBtn || !mainAtcBtn) return;
        stickyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          mainAtcBtn.click();
        });
      }
    });
});